var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleAdsLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 49,
    viewBox: "0 0 54 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21730_141647)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.51573 35.2283L19.2532 4.86206C21.5063 6.18853 32.8677 12.4761 34.7025 13.6719L16.9651 44.0399C15.0252 46.6027 -0.941875 39.1174 1.51573 35.2267V35.2283Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4783 35.2276L34.7408 4.86322C32.2611 0.736475 26.9206 -0.763212 22.534 1.67414C18.1474 4.1115 16.8118 9.36187 19.2915 13.6729L37.029 44.041C39.5087 48.1659 44.8494 49.6654 49.236 47.2282C53.4308 44.7907 54.958 39.3541 52.4783 35.2312V35.2276Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.19066 48.4018C14.1081 48.4018 18.0944 44.5144 18.0944 39.7192C18.0944 34.9239 14.1081 31.0366 9.19066 31.0366C4.27323 31.0366 0.286865 34.9239 0.286865 39.7192C0.286865 44.5144 4.27323 48.4018 9.19066 48.4018Z",
    fill: "#34A853"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21730_141647"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53.4261,
    height: 48,
    fill: "white",
    transform: "translate(0.286865 0.500244)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleAdsLogo);
export default __webpack_public_path__ + "static/media/google-ads-logo.2097451419b13d80f5c6da495b1ed092.svg";
export { ForwardRef as ReactComponent };